// extracted by mini-css-extract-plugin
export default {"tooltip":"iA-z","arrow":"jA-z"};